var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.tabName,
            callback: function ($$v) {
              _vm.tabName = $$v
            },
            expression: "tabName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "Import", name: "import" } },
            [_c("import-warehouse")],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "Export", name: "export" } },
            [_c("export-warehouse")],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "Report", name: "report" } },
            [_c("report-warehouse", { attrs: { tabName: _vm.tabName } })],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "Expired", name: "expired" } },
            [_c("report-expired-warehouse")],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "Consignment", name: "consign" } },
            [_c("report-consignment")],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }